import { Day } from '@progress/kendo-date-math'
import { StartDay, ViewMode } from 'types/calendar'

export const ONE_MINUTE_IN_MS = 60000
export const ONE_DAY_IN_MS = 24 * 60 * ONE_MINUTE_IN_MS

export function getWeek(start = 0, today = new Date()) {
    const date = new Date(today)
    date.setHours(0, 0, 0, 0)
    const start_date = new Date(date.setDate(date.getDate() - (date.getDay() - start)))
    const end_date = new Date(start_date.getTime() + ONE_DAY_IN_MS * 6)
    end_date.setHours(23, 59, 59)
    return [start_date, end_date]
}

/**
 * start date is adjusted based on the calendar start_day and the current date
 * 
 * @param start_day 
 * @param dt 
 * @returns 
 */
export function getCalendarWeek(start_day: string, dt = new Date(), view_mode?: ViewMode) {
    if (view_mode == ViewMode.MONTH) {
        let start = new Date(dt)
        let end = new Date(dt)
        start.setDate(1)
        end.setFullYear(dt.getFullYear(), dt.getMonth() + 1, 0)
        return [start, end]
    }
    return getWeek(start_day == StartDay.SUNDAY ? 0 : (dt.getDay() == 0 ? -6 : 1), dt)
}

export function getDateOfWeek(day_of_week = 'Sunday', today = new Date()) {
    today.setHours(0, 0, 0, 0)
    day_of_week = day_of_week.charAt(0) + day_of_week.slice(1).toLowerCase()
    var day = Day[day_of_week as any as Day]
    var date = today.getDate() + (parseInt(day) - today.getDay())
    var short_date = new Date(today.setDate(date))
    return short_date
}
